import React from "react";

const BlogFilters = ({ typeFilter, setTypeFilter, languageFilter, setLanguageFilter }) => {
  return (
    <div className="d-flex gap-3" style={{ gap: "10px" }}>
      <div className="form-group mb-0" style={{ minWidth: "200px" }}>
        <select
          id="typeFilter"
          value={typeFilter}
          onChange={(e) => setTypeFilter(e.target.value)}
          className="form-control"
        >
          <option value="">All Types</option>
          <option value="BLOGS">BLOGS</option>
          <option value="CASE_STUDIES">CASE STUDIES</option>
          <option value="TECH_BLOGS">TECH BLOGS</option>
          <option value="SUCCESS_STORIES">SUCCESS STORIES</option>
        </select>
      </div>
      <div className="form-group mb-0" style={{ minWidth: "200px" }}>
        <select
          id="languageFilter"
          value={languageFilter}
          onChange={(e) => setLanguageFilter(e.target.value)}
          className="form-control"
        >
          <option value="">All Languages</option>
          <option value="ENG">ENG</option>
          <option value="JAP">JAP</option>
        </select>
      </div>
    </div>
  );
};

export default BlogFilters;

